<template>
  <section class="pd-y-30">
    <div class="container" v-if="tasks.length > 0">
      <div class="d-flex align-items-center ">
        <h2>{{ comp.task }}</h2>
        <router-link
          :to="{
            name: $store.state.app.activeGroup.publicPage.route,
            params: {
              id: $store.state.app.pages.filter(x => x.st1 == 'courses')[0].id,
              cid: 0
            }
          }"
          class="mg-l-auto"
          >Бүх сургалтыг үзэх</router-link
        >
      </div>

      <table class="table table-hover table-bordered">
        <thead>
          <tr>
            <th scope="col">Д/д</th>
            <th scope="col">Сургалтын нэр</th>
            <!-- <th scope="col">Хугацаа</th>
            <th scope="col">Үнэ</th> -->
          </tr>
        </thead>
        <tbody>
          <template v-for="(t, i) in tasks">
            <tr v-if="isDrawGroupDateRange(i)">
              <td class="bg-gray-50 text-muted" colspan="4">{{ t.locTypeName }}</td>
            </tr>
            <tr @click="$emit('on-course-info', t)" role="button">
              <th scope="row">{{ i+1 }}</th>
              <td>
                <div class="d-flex align-items-center tx-semibold">
                  <img :alt="t.task" :title="t.task" :src="`${t.defaultAttachmentUrl}?w=40&h=25&mode=crop`" class="mg-r-5 rounded-5" />
                  {{ t.task }}
                </div>
              </td>
              <!-- <td class="text-muted">{{ getRange(t) }}</td>
              <td>{{ t.budget }} ₮</td> -->
            </tr>
          </template>
        </tbody>
      </table>

      <!-- <div class="row">
        <div
          @click="$emit('on-course-info', t)"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
          v-for="(t, i) in tasks"
          :key="i"
          role="button"
        >
          <div class="card top-courses mg-b-30">
            <div class="card-body pd-0">
              <img
                :src="`${t.defaultAttachmentUrl}?w=450&h=200&mode=crop`"
                class="wd-100p"
              />
            </div>
            <div class="card-footer pd-y-20 bg-white">
              <div class="d-flex tx-12">
                <span>Оролцогчийн лимит: {{ t.i7 == 1 ? t.i1 : "Хязгааргүй" }}</span>
                <span class="mg-l-auto"
                  >Хугацаа:
                  {{ t.flag == 9 ? t.i2 : getDuration(t) }} хоног</span
                >
              </div>
              <h5 class="mg-y-20">{{ t.task }}</h5>
              <h6>{{ t.budget }} ₮</h6>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div v-else class="container pd-y-100 tx-center">
      <div
        class="ht-100p d-flex flex-column align-items-center justify-content-center"
      >
        <h1 class="tx-color-01 tx-24 tx-sm-32 tx-lg-36 mg-xl-b-5">
          Сургалт хоосон байна
        </h1>
        <h5 class="tx-16 tx-sm-18 tx-lg-20 tx-normal mg-b-20">
          [{{ $route.params.keyword }}]-хайлтад хараахан нээлттэй сургалт зарлагдаагүй байна.
        </h5>
        <p class="tx-color-03 mg-b-30">
          Та <a @click="$router.back()" role="button"
            class="text-primary"
            >[энд дарж]</a> сургалтууд хэсгээс өөрт тохирох сургалтыг сонгон суралцана уу.
        </p>
        <div class="d-flex mg-b-40">
          <router-link
            :to="{
              name: $store.state.app.activeGroup.publicPage.route,
              params: {
                id: $store.state.app.pages.filter(x => x.st1 == 'courses')[0]
                  .id,
                cid: 0
              }
            }"
            class="btn btn-brand-02 bd-0 mg-l-5 pd-sm-x-25 text-white"
            >Бүх сургалтыг үзэх</router-link
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { request } from "@/api/all";
const moment = require("moment");

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tasks: [],
      type: {}
    };
  },
  mounted() {
    this.loadTasks();
  },
  methods: {
    getRange(task) {
      const startDate = moment(task.dueStartDate);
      const endDate = moment(task.dueDate);
      
      // Format dates as YYYY.MM.DD
      const startFormatted = startDate.format('YYYY.MM.DD');
      const endFormatted = endDate.format('YYYY.MM.DD');
      
      // If same year
      if (startDate.year() === endDate.year()) {
        // If same month
        if (startDate.month() === endDate.month()) {
          return `${startDate.format('YYYY.MM')}.${startDate.format('DD')}-${endDate.format('DD')}`;
        }
        // Different months, same year
        return `${startDate.format('YYYY.MM.DD')}-${endDate.format('MM.DD')}`;
      }
      
      // Different years
      return `${startFormatted}-${endFormatted}`;
    },
    isDrawGroupDateRange(i) {
      let _fname = "locTypeName";
      if (i == 0) {
        return true;
      } else if (this.tasks[i][_fname] != this.tasks[i - 1][_fname]) {
        return true;
      } else {
        return false;
      }
    },
    loadTasks() {
      let sizes = 20;
      if (this.$store.state.app.pages.filter(x => x.st1 == "courses").length) {
        if (
          this.$route.params.id ==
          this.$store.state.app.pages.filter(x => x.st1 == "courses")[0].id
        ) {
          sizes = 100;
        }
      }

      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: sizes,
          ot: 115,
          model: {
            isPublic: true,
            locTypeId:
              this.$route.params.cid != 0 ? this.$route.params.cid : null,
            task: this.$route.params.keyword != null ? this.$route.params.keyword : null
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          if (res.data.tasks.length > 0) {
            this.tasks = res.data.tasks;
            this.tasks = _.orderBy(this.tasks, ["locTypeName"], ["asc"]);
          } else this.typeDetail();
        }
      });
    },
    getDuration(t) {
      var start = moment(t.createdDate);
      var due = moment(t.dueDate);
      return due.diff(start, "days");
    },
    typeDetail() {
      request({
        api: { method: "GET", url: "type/GetInheritedDetail" },
        params: {
          id: this.$route.params.cid,
          key: "courseType"
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.type = res.data;
        }
      });
    }
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (newRoute.params.cid != oldRoute.params.cid) {
        this.$nextTick(() => {
          this.loadTasks();
        });
      }
    }
  }
};
</script>

<style></style>
